/*
    SUMMARY
    0 - FUNCTION
    1 - BUTTON (CONFIRM COOKIES)
    2 - VERIFY IF COOKIES IS ACTIVE
*/


export default function cookies() {
    /*-----------------------/ 0 - FUNCTION /------------------*/
    function saveCookies() {
        localStorage.setItem("@CookiesSaved-Knight", true);
    }

    /*-----------------------/ 1 - BUTTON (CONFIRM COOKIES) /------------------*/
    window.onload = function () {
        const btnConfirmCookies = document.getElementById("btn--confirm-cookies");

        if (btnConfirmCookies) {
            btnConfirmCookies.addEventListener("click", () => {
                console.log("Botão clicado!");

                // Esconde a mensagem de cookies
                document.querySelector(".cookie--message").classList.add("disabled");

                // Salva a informação no localStorage
                saveCookies();
            });
        } else {
            console.error("Erro: O botão de cookies não foi encontrado!");
        }
    };

    /*-----------------------/ 2 - VERIFY IF COOKIES IS ACTIVE /------------------*/
    const modalCookies = document.querySelector(".cookie--message");

    if (localStorage.getItem("@CookiesSaved-Knight")) {
        if (modalCookies) {
            modalCookies.style.display = "none";
        }
    } else {
        if (modalCookies) {
            modalCookies.classList.add("active");
        }
    }
}

